export default class ProductHelper {

  static getProductsForTreeModel(products) {
    let treeModel = this.createTreeModel(products);
    return treeModel;
  }

  static createTreeModel(sourceElements) {
    let targetElements = [];

    for (let i = 0; i < sourceElements.length; i++) {
      let sourceElement = sourceElements[i];

      const nextLevel = this.determineLevel(sourceElement["TABELLE"]);
      if (nextLevel === -1) {
        // Unknown entry
        continue;
      }

      let newNode = this.mapNode(sourceElement, nextLevel, i);

      // Do not take the first node of a lower level as the parent.
      // A missing level like 1 - 3 - 4, would lead to a wrong parent.
      let parentNode = null;
      let lookUpwards = nextLevel - 1;
      while (lookUpwards >= 1) {
        const parentCandidate = this.findLastOfLevel(targetElements, lookUpwards);
        if (parentNode === null || parentCandidate["flatindex"] > parentNode["flatindex"]) {
          parentNode = parentCandidate;
        }
        lookUpwards--;
      }
      
      if (parentNode == null) {
        // The root level is an array and does not have a parent
        parentNode = targetElements;
        parentNode.push(newNode);
      } else {
        if (parentNode["level"] === 3) {
          // The node for a standard order is not displayed, but it is added to the model
          if (!parentNode.hasOwnProperty("standardorders")) {
            parentNode["standardorders"] = [];
          }
          parentNode["standardorders"].push(sourceElement["PARAMETER2"]);
        } else {
          // The nodes of level 1 to 3 are added as visible children
          if (!parentNode.hasOwnProperty("nodes")) {
            parentNode["nodes"] = [];
          }
          parentNode["nodes"].push(newNode);
        }
      }
    }

    return targetElements;
  }

  static mapNode(sourceElement, nextLevel, flatindex) {
    return {
      key: sourceElement["PSTA_ID"],
      pstaid: sourceElement["PSTA_ID"],
      label: sourceElement["PARAMETER3"],
      labelenglish: sourceElement["PARAMETER4"],
      productinfo: sourceElement["PARAMETER5"],
      productinfoenglish: sourceElement["PARAMETER6"],
      contactinfo: sourceElement["PARAMETER7"],
      contactinfoenglish: sourceElement["PARAMETER8"],
      level: nextLevel,
      flatindex: flatindex
    };
  }

  static findLastOfLevel(targetElements, level) {
    let lastElement = null;

    for (let i = targetElements.length - 1; i >= 0; i--) {
      let element = targetElements[i];

      if (element.level === level) {
        lastElement = element;
        break;
      }

      if (element["nodes"] && element["nodes"].length > 0) {
        lastElement = this.findLastOfLevel(element["nodes"], level);
        if (lastElement != null) {
          break;
        }
      }
    }

    return lastElement;
  }

  static determineLevel(levelIdentifier) {
    let result;

    switch (levelIdentifier) {
      case "WSHOP2.KATALOG-GRP1": {
        result = 1;
        break;
      }
      case "WSHOP2.KATALOG-GRP2": {
        result = 2;
        break;
      }
      case "WSHOP2.KATALOG-GRP3": {
        result = 3;
        break;
      }
      case "WSHOP2.KATALOG-GRP4-STD": {
        result = 4;
        break;
      }
      default: {
        // Unknown entry
        result = -1;
      }
    }

    return result;
  }

  static getStandardOrdersForLevel3Node(sourceElements, key) {
    let standardOrders = [];

    let addStandardOrders = false;
    for (let sourceElement of sourceElements) {
      if (addStandardOrders === false) {
        if (
          "WSHOP2.KATALOG-GRP3" === sourceElement["TABELLE"] &&
          key === sourceElement["PSTA_ID"]
        ) {
          // Level 3 node found -> Add all following level 4 nodes
          addStandardOrders = true;
        }
      } else {
        if ("WSHOP2.KATALOG-GRP4-STD" === sourceElement["TABELLE"]) {
          standardOrders.push(sourceElement);
        } else {
          addStandardOrders = false;
          break;
        }
      }
    }

    return standardOrders;
  }

  static getAllChildren(sourceElements, key, addSelf = false) {
    let result = [];

    let baseLevel = -1;
    if (sourceElements.length > 0) {
      for (let i = 0; i < sourceElements.length; i++) {
        const sourceElement = sourceElements[i];
        const currentLevel = this.determineLevel(sourceElement["TABELLE"]);

        if (baseLevel === -1 && sourceElement["PSTA_ID"] === key) {
          baseLevel = currentLevel;
          // Add base node itself
          if (addSelf === true) {
            result.push(sourceElement);
          }
        }
        // Do not search in level 4 standard orders (WSHOP2.KATALOG-GRP4-STD)
        else if (baseLevel !== -1 && sourceElement["PSTA_ID"] !== key && currentLevel !== 4) {
          if (currentLevel > baseLevel) {
            // Add child
            result.push(sourceElement);
          } else {
            // Same or lower level is no child
            break;
          }
        }
      }

      return result;
    }
  }

  static getAllParents(sourceElements, key, addSelf = false) {
    let result = [];

    let baseLevel = -1;
    let lastLevel = -1;
    if (sourceElements.length > 0) {
      for (let i = sourceElements.length - 1; i >= 0; i--) {
        const sourceElement = sourceElements[i];
        const currentLevel = this.determineLevel(sourceElement["TABELLE"]);

        if (baseLevel === -1 && sourceElement["PSTA_ID"] === key) {
          baseLevel = currentLevel;
          lastLevel = currentLevel;
          // Add base node itself
          if (addSelf === true) {
            result.push(sourceElement);
          }
        }
        // Do not search in level 4 standard orders (WSHOP2.KATALOG-GRP4-STD)
        else if (baseLevel !== -1 && sourceElement["PSTA_ID"] !== key && currentLevel !== 4 && currentLevel < lastLevel) {
          result.push(sourceElement);
          lastLevel = currentLevel;
        }
      }
    }

    return result;
  }
}
